module.exports = __webpack_public_path__ + "common/kamii-icon/chevronRight-4473c6cf3842196e1e0b018fbb173293.svg";